import React from 'react';
import { FaArrowCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
import { IoMdArrowDropup } from "react-icons/io";
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../../../../../header/header';
import Navvbar from '../../../../../../header/Navvbar';
import Footer from '../../../../../../footer.js'; // Adjust path if needed

const ProcedureGroups = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    navigate('/add-procedure-group');
  };

  return (
    <>
      <div style={{ marginBottom: "25px" }}>
        <Header />
        <Navvbar />
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-10">
            <h2
              style={{
                color: '#333',
                margin: '0 0 10px 0',
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              Procedure Groups
            </h2>
            <div
              style={{
                color: '#004aad',
                marginTop: '40px',
                cursor: 'pointer',
                margin: '0 0 0 0',
                fontWeight: 'bold',
              }}
            >
              Details
            </div>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '10px',
                borderTop: '2px solid #004aad',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginLeft: '5px', color: '#555' }}>Search:</span>
                  <input
                    type="text"
                    placeholder=""
                    style={{
                      padding: '5px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                  />
                </div>
                <div>
                  <button
                    style={{
                      backgroundColor: '#004aad',
                      color: 'white',
                      border: 'none',
                      padding: '5px 10px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      marginBottom: '5px',
                    }}
                    onClick={handleAddClick}
                  >
                    + Add
                  </button>
                  <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                    <span style={{ cursor: 'pointer' }}>
                      <FaArrowCircleLeft />
                    </span>
                    <span style={{ cursor: 'pointer' }}>
                      <FaArrowAltCircleRight />
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ color: '#555', fontSize: '14px', marginBottom: '10px' }}>
                Showing 0 to 0 of 0 entries
              </div>
              <div style={{ padding: '10px', textAlign: 'left' }}>
                <div
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  Name
                  <IoMdArrowDropup style={{ color: '#004aad', marginLeft: '960px' }} />
                </div>
              </div>
            </div>

            {/* No data message with hover effect */}
            <div
              style={{
                textAlign: 'center',
                color: '#555',
                padding: '10px',
                marginTop: '-20px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                borderRadius: '4px',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f4f4f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
            >
              No data available in table
            </div>

            {/* Bottom section */}
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '10px',
                borderTop: '2px solid #004aad',
                marginTop: '-5px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div style={{ color: '#555', fontSize: '14px' }}>
                  Showing 0 to 0 of 0 entries
                </div>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <span style={{ cursor: 'pointer' }}>
                    <FaArrowCircleLeft />
                  </span>
                  <span style={{ cursor: 'pointer' }}>
                    <FaArrowAltCircleRight />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default ProcedureGroups;